<ol [class.readonly]="readonly">
  <li *ngFor="let item of steps; index as i"><button
    [disabled]="readonly"
    (click)="setStep(i)"
    [class.current]="steps.current === i"
    [class.done]="i < (steps.current || 0)"> {{item.title}}</button></li>
</ol>